/**
 * Orders Empty State Component
 */

import { TableEmptyState } from '@ufc/uikit'
import { ShoppingCart } from '@ufc/uikit'
import { useTranslation } from '@ufc/core'

export function OrdersEmptyState() {
  const { t } = useTranslation()

  return (
    <div className="glass-card rounded-2xl overflow-hidden">
      <TableEmptyState
        icon={ShoppingCart}
        title={t('orders.noOrders')}
        description={t('orders.noOrdersDescription')}
      />
    </div>
  )
}
